// extracted by mini-css-extract-plugin
export default {"root":"Tag_root__Wn069","clear":"Tag_clear__7Hbjf","text":"Tag_text__WYQj2","selected":"Tag_selected__3qGWS","disabled":"Tag_disabled__K+eZQ"};